export let productPhone = [
  { id: 1, src: "Assets/Card 3.png" },
  { id: 2, src: "Assets/Card 6.png" },
  { id: 3, src: "Assets/Card 5.png" },
  { id: 4, src: "Assets/Card 4.png" },
  { id: 5, src: "Assets/Card 10.png" },
  { id: 6, src: "Assets/Card 101.png" },
  { id: 7, src: "Assets/Card 120.png" },
  { id: 8, src: "Assets/Card 130.png" },
];
export let laptops = [
  { id: 1, src: "Assets/Card 111.png" },
  { id: 2, src: "Assets/Card 112.png" },
  { id: 3, src: "Assets/Card 113.png" },
  { id: 4, src: "Assets/Card 114.png" },
];
